'use strict';
import * as msal from "@azure/msal-browser";
import {siteConfig} from '../siteConfig';
module.exports = function ($state, $http, Authentication, $timeout) {
    var _this = this;
    this.user = {};
    this.loading = false;
    this.loadingProgress = null;
    this.loginError = false;
    this.siteConfig = siteConfig;
    window.document.title = siteConfig.productName || "Field Platform By Voolks";   
    this.showPassword = false;     

    
    this.loginAzureAD = function () {  
        if(this.siteConfig.AuthStrategy=="SAML"){
            window.location.href=this.siteConfig.urlUserAccess;
            return;
        }
        const msalConfig = {
            auth: this.siteConfig,
            cache: {
                cacheLocation: "sessionStorage", // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
            system: {
                loggerOptions: {
                    loggerCallback: (level, message, containsPii) => {
                        if (containsPii) {
                            return;
                        }
                        switch (level) {
                            case msal.LogLevel.Error:
                                console.error(message);
                                return;
                            case msal.LogLevel.Info:
                                console.info(message);
                                return;
                            case msal.LogLevel.Verbose:
                                console.debug(message);
                                return;
                            case msal.LogLevel.Warning:
                                console.warn(message);
                                return;
                        }
                    }
                }
            }
        };
        const loginRequest = {
            scopes: ["User.Read"]
        };
        const myMSALObj = new msal.PublicClientApplication(msalConfig);
        myMSALObj.loginPopup(loginRequest)
            .then((response) => {
                let user= { 
                    azureAD:true,
                    email:response.account.username,                   
                    password:response.accessToken
                }                   
                _this.login(user);
            })
            .catch(error => {
                console.error(error);
            });
    }

    this.login = function (user) {
        _this.loginError = false;
        _this.loading = true;
        _this.loadingProgress = 'LOGIN.PROGRESS.LOADING_PROFILE';
        Authentication.login(user || _this.user, (step) => {
            _this.loadingProgress = step;
        })
            .then(function (departments) {
                _this.loadingProgress = 'LOGIN.PROGRESS.REDIRECTING';
                _this.loginSuccess = true;
                _this.user = user;
                $timeout(function () {
                    _this.loading = false;
                    /* if (!departments.length) {
                        if(Authentication.isAuthorized("admin"))
                            return $state.go('dashboard.departments');
                        else{
                            throw("Error no depts")
                        }
                    } */
                    if (Authentication.isAuthorized("viewer") && siteConfig.viewerToWebapp != undefined) {
                        const fromBuilder =
                        {
                            id: window.localStorage.$LoopBack$accessTokenId,
                            user: Authentication.currentUserInfo().user || Authentication.currentUserInfo(),
                        }
                        const fromBuilderB64 = btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(fromBuilder))));                        
                        window.location.replace(siteConfig.webapp[siteConfig.viewerToWebapp].url.concat("/fromBuilder#", fromBuilderB64))
                    } else
                    if (Authentication.isAuthorized("viewer")) {
                        let deptId = localStorage.getItem('lastDepartment');
                        let departmentExists = departments.find(dept => dept.id == deptId);
                        let targetDeptId = departmentExists ? deptId : departments[0].id;
                        return $state.go('dashboard.departments.department.forms', {
                            departmentId: targetDeptId
                        });
                    } else {
                        // console.log('certdigital 1', _this.siteConfig)
                        if (_this.siteConfig?.tags?.includes('certdigital') && Authentication.isAuthorized(['owner', 'supervisor'])) {
                            // console.log('es owner o supervisor')
                            return $state.go('dashboard.validations');
                        }
                        if (Authentication.isAuthorized('supervisor')) {
                            return $state.go('dashboard.validations');
                        }

                        let deptId = localStorage.getItem('lastDepartment');
                        let departmentExists = departments.find(dept => dept.id == deptId);
                        let targetDeptId = departmentExists ? deptId : departments[0].id;
                        return $state.go('dashboard.departments.department', {
                            departmentId: targetDeptId
                        });
                    }
                }, 900);
            })
            .catch(function (error) {
                _this.loading = false;
                _this.loadingProgress = null;
                _this.loginError = true;
                _this.user.password = null;
                Authentication.logOut();
            });
    };
};
